

















































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";
import { notifyError, notifySuccess } from "@/common/notify";

import { LibraryParent, LibraryTerm, LibraryTermRequest } from "@/interfaces";
import { createLibraryTerm, updateLibraryTerm } from "@/services";

const defaultTerm: LibraryTermRequest = {
  name: "",
  library: "",
  // eslint-disable-next-line @typescript-eslint/camelcase
  parent_id: undefined,
};

@Component
export default class NewLibraryTermDialog extends Vue {
  @Ref("new-library-term-dialog")
  dialog!: QDialog;

  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: String, required: true })
  librarySlug!: string;

  @Prop({ type: Array, required: true })
  parents!: LibraryParent;

  @Prop({ type: Object, required: false })
  term!: LibraryTerm;

  termData: LibraryTermRequest = { ...defaultTerm };

  loading = false;

  created() {
    if (this.term) {
      this.termData = {
        name: this.term.name,
        library: this.librarySlug,
        // eslint-disable-next-line @typescript-eslint/camelcase
        parent_id: this.term.parent_id,
      };
    }
  }

  async onSubmit() {
    try {
      this.loading = true;
      const data = {
        ...this.termData,
        library: this.librarySlug,
      };
      let result: LibraryTerm;

      if (this.term) {
        result = await updateLibraryTerm(this.term.id, data);
      } else {
        result = await createLibraryTerm(data);
      }

      notifySuccess("Operazione avvenuta con successo!");
      this.$emit("ok", result);
      this.termData = { ...defaultTerm };
      this.hide();
    } catch (e) {
      notifyError(`Si è verificato un errore durante la ${this.term ? "modifica" : "creazione"} del termine`);
    } finally {
      this.loading = false;
    }
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
